import { defineMessages } from 'react-intl';

export const scope = 'app.components.RequestEmailsPage';

export const messages = defineMessages({
  btnRequest: {
    id: `${scope}.btnRequest`,
    defaultMessage: 'Request Emails',
  },
  btnRequesting: {
    id: `${scope}.btnRequesting`,
    defaultMessage: 'Sending…',
  },
  msgSent: {
    id: `${scope}.msgSent`,
    defaultMessage: 'Emails sent',
  },
  errSendFailed: {
    id: `${scope}.errSendFailed`,
    defaultMessage: "Some of your emails couldn't be sent. Please try again — emails that already went out won't be sent twice.",
  },
});
